























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Booking } from "@/components/Booking/models/Booking";
import './BookingList.scss'
import { Guid } from "guid-typescript";
import Destination from "@/components/Passenger/models/Destination";
import moment from 'moment';
import BookingListItem from "@/components/Booking/components/BookingListItem.vue";
import { Passenger } from "@/components/Passenger/models/Passenger";
import Routes from '@/Routes';
import BookingEditor from '@/components/Booking/components/BookingEditor.vue';
import { RolePermission } from '@/models/Role';
import BookingState, { BookingStates } from '@/components/Booking/models/BookingStates';
import User from '../../../models/User';

@Component({
    components: {
      BookingListItem
    },
  })
export default class BookingList extends Vue {

    mounting: boolean = true;
    editedBookingId: Guid = null;
    showBookingEditor: boolean = false;
    stateFilter: string = 'pending';
    selectableBookingStates: BookingState[] = BookingStates.SelectableStates;
    $t: any;

    headers: any[] = [ 
      { 
        i18n: 'booking.table.header.idNumber',
        text: 'ID', 
        align: 'left', 
        value: 'shortId',
        hasCustomTemplate: true
      },
      { 
        i18n: 'booking.table.header.bookingDate',
        text: '[Date]', 
        align: 'left', 
        value: 'bookingDate',
        hasCustomTemplate: true
      },
      { 
        i18n: 'booking.table.header.fromAddress',
        fi: 'Lähtöpaikka', 
        text: 'From', 
        align: 'left', 
        value: 'fromAddress',
      },
      { 
        i18n: 'booking.table.header.toAddress',
        fi: 'Määränpää', 
        text: 'To', 
        align: 'left', 
        value: 'toAddress',
      },
      { 
        i18n: 'booking.table.header.passenger',
        text: 'Matkustaja', 
        align: 'left', 
        value: 'primaryPassengerName'
      },
      { 
        i18n: 'booking.table.header.createdBy',
        fi: 'Tekijä', 
        text: 'Created by', 
        align: 'left', 
        value: 'createdByNameFromEmail'
      },
      // { 
      //   i18n: 'booking.table.header.state',
      //   fi: 'Tila', 
      //   text: 'State', 
      //   align: 'left', 
      //   value: 'stateName',
      //   hasCustomTemplate: true
      // },
      { 
        // i18n: '',
        // fi: '', 
        text: '  ', 
        align: 'right', 
        value: 'actions',
        sortable: false,
        hasCustomTemplate: true
      }
    ]

    // get pagination(): any {
    //   return this.$store.state.app.bookingListDataTablePagination;
    // }

     // set pagination(val: any){
    //   this.$store.dispatch("app/setBookingListDataTablePagination", val);
    // }

    pagination: any = {
      sortBy: 'startDate', 
      descending: false, 
      rowsPerPage: -1
    }

    // bookingPassengersIds(booking: Booking): number[] {
    //   return booking.bookingPassengers.map(tp => tp.passengerId);
    // }

    onTableHeaderClick(column){
      const pagination = Object.assign({}, this.pagination);
      if (pagination.sortBy === column) {
        pagination.descending = !pagination.descending;
      } else {
        pagination.sortBy = column;
        pagination.descending = false;
      }
      this.pagination = pagination;
    }

    onDatatableSort(items, index, isDesc) {
      // console.time("onDatatableSort");
      items.sort((a: Booking, b: Booking) => {
        if (index === "summary") {
          const passengerCountA = a.passengerCount;
          const passengerCountB = b.passengerCount;
          if (isDesc) {
            return passengerCountB < passengerCountA ? -1 : 1;
          } else {
            return passengerCountA < passengerCountB ? -1 : 1;
          }
        } else {
          if (isDesc) {
            return b[index] < a[index] ? -1 : 1;
          } else {
             return a[index] < b[index] ? -1 : 1;
          }
        }
      });
      // console.timeEnd("onDatatableSort");
      return items;
    }
   
    get isLoading(): boolean {
      return this.$store.state.booking.pending.bookings ||
        this.$store.state.destination.pending.destinations;
    }

    @Watch("isLoading")
    onIsLoadingChanged(val, oldVal){
      // Dispatch window resize event to make the state tabs autosize
      window.dispatchEvent(new Event("resize"));
    }

    get showExpiredBookings(): boolean {
        return this.$store.state.app.showExpiredBookings;
    }
    set showExpiredBookings(val) {
        this.$store.dispatch("app/setShowExpiredBookings", val);
    }

    get showOnlyMyBookings(): boolean {
        return this.$store.state.app.showOnlyMyBookings;
    }
    set showOnlyMyBookings(val) {
        this.$store.dispatch("app/setShowOnlyMyBookings", val);
    }

    get showBookingsAsList(): boolean {
        return this.$store.state.app.showBookingsAsList;
    }
    set showBookingsAsList(val) {
        this.$store.dispatch("app/setShowBookingsAsList", val);
    }

    get me(): User {
      return this.$store.state.user.me;
    }

    get selectedBookingId(): Guid {
      return this.$store.state.route.params.bookingId;
    }

    // get bookings(): Booking[] {
    //   if (this.showExpiredBookings){
    //     return this.$store.state.booking.bookings;
    //   } else {
    //     return this.$store.state.booking.bookings.filter((t: Booking) => !t.hasExpired);
    //   }
    // }

    get storeBookings(): Booking[] {
      return this.$store.state.booking.bookings
    }

    get destinationBookings(): Booking[] {
      return this.storeBookings 
        ? this.storeBookings.filter(t => 
            t.destinationId === this.routeDestinationId &&
            (!t.hasExpired || this.showExpiredBookings) &&
            ((t.createdByEmail === this.me.email && this.showOnlyMyBookings) || !this.showOnlyMyBookings)
          )
        : [];
    }

    get filteredDestinationBookings(): Booking[] {
      const bookings = this.destinationBookings
      .filter(t => t.state === this.routeStateId )
      .filter(t => t);
      return bookings;
    }

    get sortedDestinationBookings(): Booking[] {
      return this.filteredDestinationBookings
      .sort(
        (a, b) => {
          if (a.bookingDate.getTime() !== b.bookingDate.getTime() ){
            return a.bookingDate.getTime() > b.bookingDate.getTime() ? 1 : -1 
          } 
          if (a.id !== b.id){
             return a.id > b.id ? -1 : 1  
          }
        }
      )
    }

    get destinations(): Destination[] {
      return this.$store.state.destination.destinations;
    }

    get destination(): Destination {
      return this.destinations.find(d => d.id === this.routeDestinationId);
    }

    get routeStateNameLowerCase(): string {
      return this.$store.state.route.params.state;
    }

    get routeState(): BookingState {
      return this.routeStateNameLowerCase 
        ? BookingStates.SelectableStates.find(s => s.nameLowerCase === this.routeStateNameLowerCase)
        : null;
    }

    get routeStateId(): number {
      return this.routeState ? this.routeState.id : 0;
    }

    @Watch('routeState', { immediate: true })
    onRouteStateChanged(val, oldVal) {
      if (val){
        this.$store.dispatch("app/setLastSelectedBookingState", this.routeState);
      }
    }

    bookingCountWithState(stateId: number): number {
      return this.destinationBookings.filter(t => t.state === stateId).length;
    }

    destinationFor(booking: Booking): Destination {
      return this.destinations.find(d => d.id === booking.destinationId);
    }

    get routeDestinationId(): number {
      return parseInt(this.$store.state.route.params.destinationId, 10);
    }

    canUserViewBookingsForDestinationId(destinationId: number): boolean {
      return this.me 
          ? this.me.hasPermissions(destinationId, [RolePermission.ReadBookings])
        : false;
    }

    @Watch('routeDestinationId', { immediate: true })
    onRouteDestinationIdChanged(val, oldVal) {
      if (!this.destination.bookingEnabled || !this.canUserViewBookingsForDestinationId(val)){
        this.$router.push("/");
      }
      if (this.destinationBookings.length === 0){
        console.log("No bookings for destination in store.");
        console.log("Getting bookings for selected destination ...");
        this.$store.dispatch(
          'booking/getDestinationBookings',
            { 
            params: { 
              destinationId: val
            } 
          }
        ); 
      }
    }

    get lastSelectedBookingId(): Guid {
      return this.$store.state.app.lastSelectedBookingId;
    }

    get userCanCreateBookings(): boolean {
        return this.me 
            ? this.me.hasPermissions(this.routeDestinationId, [RolePermission.CreateBookings])
            : false;
    }

    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    get lastSelectedBookingState(): BookingState{
      return this.$store.state.app.lastSelectedBookingState;
    }

    get lastSelectedBookingStateNameLowerCase(): string {
      return this.lastSelectedBookingState 
        ? this.lastSelectedBookingState.nameLowerCase
        : null;
    }

    @Watch('$route', { immediate: true })
    onRouteChanged(val, oldVal) {
       if (!this.routeState){
        this.$router.replace({
          name: Routes.bookingListWithStateRoute.name, 
          params: { 
              state: this.lastSelectedBookingStateNameLowerCase ? this.lastSelectedBookingStateNameLowerCase : 'open'
          }
        })
      }
    }

    async mounted() {
      this.mounting = true;
      if (this.lastSelectedBookingId && this.showBookingsAsList){
        // copy the value from store to a local variable, so it's there after the timeout
        const lastSelectedBookingId = this.lastSelectedBookingId;
        const bookingElement = document.querySelector("[data-booking-id='" + lastSelectedBookingId + "']");
        if (bookingElement){

          await this.timeout(400);       
          // console.log("Scrolling booking", lastSelectedBookingId, "into view...");
          bookingElement.scrollIntoView({
            behavior: "auto",
            block: "center",
          });
          this.mounting = false;

          await this.timeout(600);
          bookingElement.classList.add("last-selected")

          await this.timeout(1000);
          bookingElement.classList.remove("last-selected")
        } else {
          this.mounting = false;
        }
        // Now that we are bringing the previously selected booking into view, we can reset astSelectedBookingId
        this.$store.dispatch("app/setLastSelectedBookingId", null);
      } else {
        this.mounting = false;
      }
    }

    get showWeekends() {
      return this.$store.state.user.showWeekends;
    }

    onCreateBookingClick() {
      this.$router.push({ name: Routes.bookingListCreateNewRoute.name, params: { state: "open" } }); 
    }

}
